import { useTranslation } from 'react-i18next'
import { useDialogControllers } from '@machobear/design-system'
import styled from 'styled-components'
import { Box, Columns, Column, Button, IconRocket } from '@machobear/design-system'
import { NoApplicationsYet } from '@/components/icons'
import { SponsoredListingProvider } from '@/features/SponsoredListing/modals/sponsor-wizard'
import { colors } from '@/styles'
import { ParagraphRegular, ParagraphMedium } from '@/components/text'
import SponsorDialogs from '@/features/SponsoredListing/components/sponsor-dialogs'
import useProfile from '@/hooks/use-profile'
import { ShareListingDialogs } from '@/features/Listing/buttons/share/share-modal'
import { useDispatch, useSelector } from 'react-redux'
import { select } from '@/store'
import { useEffect } from 'react'

const NoApplicantHeading = styled(ParagraphRegular)`
  color: ${colors.grey16};
  font-weight: 500;
`

const SponsorHeading = styled(ParagraphMedium)`
  color: ${colors.grey16};
  justify-content: center;
  text-align: center;
`

const EmptyApplications = ({ listingId }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const profileData = useProfile()
  const isBillingUserValid = profileData?.billing_user_valid

  const { visible, showModal, closeModal } = useDialogControllers({
    billingUser: false,
    sponsoredListing: false,
    nextSteps: false,
    checkoutDialog: false,
    editPaymentDialog: false,
    mainDialog: false,
    emailDialog: false,
    phoneDialog: false,
    craigslistDialog: false,
    kijijiDialog: false,
    facebookDialog: false
  })

  const data = useSelector(state =>
    select.listing.editListing(state, {
      listingId
    })
  )

  useEffect(() => {
    if (Object.keys(data).length > 0) return
    dispatch.listing.load(listingId)
  }, [])

  const handleShareClick = () => {
    showModal('mainDialog')()
  }

  const handleBoostListing = () => {
    if (isBillingUserValid) {
      showModal('sponsoredListing')()
    } else {
      showModal('billingUser')()
    }
  }

  return (
    <>
      <Box
        display="flex"
        paddingY="xxxlarge"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        position="relative"
      >
        <Box
          justifyContent="center"
          alignItems="center"
          display="flex"
          flexDirection="column"
          style={{ gap: '32px' }}
        >
          <NoApplicationsYet />
          <Box
            justifyContent="center"
            alignItems="center"
            display="flex"
            style={{ gap: '28px' }}
            flexDirection="column"
          >
            <Box
              justifyContent="center"
              alignItems="center"
              display="flex"
              flexDirection="column"
              style={{ gap: '8px' }}
            >
              <NoApplicantHeading>
                {t(
                  'l.listing.application.empty_applications.no_applications.header',
                  'This listing has no applicants.'
                )}
              </NoApplicantHeading>
              <SponsorHeading>
                {t(
                  'l.listing.application.empty_applications.sponsor.header',
                  'Share or sponsor your listing to get more applications.'
                )}
              </SponsorHeading>
            </Box>
            <Columns space="gutter">
              <Column width="content">
                <Button
                  variant="ghost"
                  size="small"
                  onClick={handleShareClick}
                  id="application-no-application-share-listing-click"
                >
                  {t('l.listing.application.empty_applications.share_button', 'Share Listing')}
                </Button>
              </Column>
              <Column width="content">
                <Button
                  variant="solid"
                  state="default"
                  size="small"
                  label="Boost Listing"
                  icon={<IconRocket />}
                  iconPosition="leading"
                  onClick={handleBoostListing}
                  id={`applications-table-empty-boost-click-${listingId}`}
                >
                  {t('l.application.table.header.boost_listing', 'Boost Listing')}
                </Button>
              </Column>
            </Columns>
          </Box>
        </Box>
      </Box>
      <SponsoredListingProvider initialStep={0} initialValues={{}} isCreateListing={false}>
        <SponsorDialogs
          listingId={listingId}
          visible={visible}
          showModal={showModal}
          closeModal={closeModal}
        />
      </SponsoredListingProvider>
      <ShareListingDialogs
        listingId={listingId}
        visible={visible}
        showModal={showModal}
        closeModal={closeModal}
      />
    </>
  )
}

export default EmptyApplications
